export const buildChangeRequest = (id, quantity, sectionsUrl) => ({
  method: 'POST',
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  body: JSON.stringify({ id, quantity, sections: ['cart-drawer'], sections_url: sectionsUrl })
});

export const drawerHtml = (payload) => payload?.sections?.['cart-drawer'] || '';

export const buildAddRequest = (formData, sectionsUrl) => {
  const body = new FormData();
  for (const [key, value] of formData.entries()) body.append(key, value);
  body.set('sections', 'cart-drawer');
  body.set('sections_url', sectionsUrl);
  return { method: 'POST', headers: { Accept: 'application/json' }, body };
};

if (typeof document !== 'undefined') {
  const drawer = () => document.querySelector('[data-cart-drawer]');
  let lastTrigger = null;

  const syncHeaderCount = () => {
    const count = drawer()?.dataset.cartCount || '0';
    document.querySelectorAll('.site-header__cart span').forEach((node) => {
      node.textContent = count;
      if (node.closest('.rf-bag')) node.classList.toggle('rf-empty-count', Number(count) === 0);
    });
  };

  const replaceDrawer = (html) => {
    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const next = template.content.querySelector('[data-cart-drawer]');
    const current = drawer();
    if (!next || !current) return false;
    current.replaceWith(next);
    syncHeaderCount();
    return true;
  };

  const openDrawer = (trigger) => {
    lastTrigger = trigger || lastTrigger;
    const root = drawer();
    if (!root) return;
    root.setAttribute('data-open', '');
    root.setAttribute('aria-hidden', 'false');
    root.querySelector('[data-cart-drawer-panel]')?.focus();
  };

  const closeDrawer = () => {
    const root = drawer();
    root?.removeAttribute('data-open');
    root?.setAttribute('aria-hidden', 'true');
    lastTrigger?.focus?.();
  };

  const changeQuantity = async (control, item, quantity) => {
    const root = drawer();
    if (!root) return;
    control.disabled = true;
    try {
      const response = await fetch(
        root.dataset.cartChangeUrl,
        buildChangeRequest(item.dataset.cartItemKey, quantity, window.location.pathname)
      );
      if (!response.ok) throw new Error('Cart update failed');
      const payload = await response.json();
      if (!replaceDrawer(drawerHtml(payload))) throw new Error('Drawer section missing');
      openDrawer();
    } catch (_error) {
      window.location.assign(root.dataset.cartUrl);
    }
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-cart-drawer-open]');
    if (open && drawer()) {
      event.preventDefault();
      openDrawer(open);
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeDrawer();
      return;
    }

    const control = event.target.closest('[data-cart-quantity-change],[data-cart-remove]');
    const item = control?.closest('[data-cart-item-key]');
    if (!control || !item) return;
    const current = Number(item.querySelector('[data-cart-quantity]')?.textContent || 0);
    const quantity = control.matches('[data-cart-remove]')
      ? 0
      : Math.max(0, current + Number(control.dataset.cartQuantityChange));
    changeQuantity(control, item, quantity);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer()?.hasAttribute('data-open')) closeDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    const root = drawer();
    if (!form || !root) return;

    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    let accepted = false;

    try {
      const response = await fetch(
        root.dataset.cartAddUrl,
        buildAddRequest(new FormData(form), window.location.pathname)
      );
      if (!response.ok) throw new Error('Add to cart failed');
      accepted = true;
      const payload = await response.json();
      const html = drawerHtml(payload);
      if (!html || !replaceDrawer(html)) {
        window.location.assign(root.dataset.cartUrl);
        return;
      }
      openDrawer(submit);
    } catch (_error) {
      if (accepted) window.location.assign(root.dataset.cartUrl);
      else HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (submit && document.contains(submit)) submit.disabled = false;
    }
  });
}
